import { PriceElement } from 'client/components/entities/price-element'
import EntityTypeEnum from 'common/enums/entityTypeEnum'
import EntityInterface from 'common/types/entities/EntityInterface'
import { OldEntityInterface } from 'common/types/entities/OldEntityInterface'
import { PriceElementInterface } from 'common/types/entities/price-element-interface'
import React from 'react'
import {
  AdditionalProps,
  createWebsiteEntityElement,
} from 'src/editor/pages/website-pricing/create-website-entity-element'

export default function createEntityElementForWebsitePricing(
  entity: EntityInterface | OldEntityInterface,
  additionalProps: AdditionalProps,
) {
  switch (entity.type) {
    case EntityTypeEnum.PriceElement:
      return (
        <PriceElement
          entity={entity as PriceElementInterface}
          key={`entity-${entity.id}`}
          {...additionalProps}
        />
      )

    default:
      return createWebsiteEntityElement(entity, additionalProps)
  }
}
